import { AlertTriangle } from "lucide-react";
import { useTrial } from "@/hooks/useTrial";

export const TrialWarningBar = () => {
  const { isOnTrial, isTrialExpired, daysRemaining, isFreeGift } = useTrial();

  if (isTrialExpired) {
    return null;
  }

  if (!isOnTrial && !isFreeGift) {
    return null;
  }


  return (
    <div className={`${isFreeGift ? 'bg-yellow-500' : 'bg-red-600'} text-white px-4 py-0.5 relative`}>
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 flex-shrink-0" />
          <span className="font-medium">
            {isFreeGift 
              ? "You are in free-gift mode. Some features may not be available."
              : `You are on trial mode. Your trial expires in ${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'}.`
            }
          </span>
        </div>
        
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-4 text-xs">
            <a
              href="https://os.growthrocks.com/home"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-white ${isFreeGift ? 'hover:text-yellow-100' : 'hover:text-red-100'} underline`}
            >
              Upgrade now
            </a>
            <a
              href="https://api.leadconnectorhq.com/widget/bookings/tmoulos-one-to-one"
              target="_blank"
              rel="noopener noreferrer"
              className={`text-white ${isFreeGift ? 'hover:text-yellow-100' : 'hover:text-red-100'} underline`}
            >
              Get a walkthrough session for free
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};